import React from 'react'
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react'
import { StatCardProps } from '../types'

const StatCard: React.FC<StatCardProps> = ({
  arrowType,
  bg,
  helpText,
  label,
  value
}) => {
  const arrowColor = useColorModeValue(
    arrowType === 'increase' ? 'green.500' : 'red.500',
    arrowType === 'increase' ? 'green.300' : 'red.300'
  )

  return (
    <Box
      bg={bg}
      borderRadius="md"
      p={4}
      shadow="sm"
    >
      <Text color="gray.500" fontSize="sm" mb={1}>
        {label}
      </Text>
      <Flex align="center">
        <Text fontSize="xl" fontWeight="bold">
          {value}
        </Text>
        {arrowType && (
          <Text as="span" color={arrowColor} ml={2}>
            {arrowType === 'increase' ? '↑' : '↓'}
          </Text>
        )}
      </Flex>
      {helpText && (
        <Text color="gray.500" fontSize="xs" mt={1}>
          {helpText}
        </Text>
      )}
    </Box>
  )
}

export default StatCard
